import { Pipe, PipeTransform } from '@angular/core';
import { HubSpokeService } from '../services/hub-spoke.service';

@Pipe({
  name: 'hubSpokeEligible'
})
export class HubSpokeEligiblePipe implements PipeTransform {

  constructor(private hubSpokeService: HubSpokeService) {}

  transform(flight: any): boolean {
    return this.hubSpokeService.isHubSpokeEligible(flight);
  }

}
